import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import CanvasSettingsTabGeneral from './canvas-settings-tab-general';

import { canvasFormStateSelector } from '../dashboard/selectors/canvas-selectors';
import { domainGroupsSelector } from '../common/selectors/domain-groups-selectors';
import { updateCanvasDataParams } from '../dashboard/actions/canvas-action-creators';

export class CanvasSettingsContentContainer extends Component{
    handleOptionChange = ( param ) => ( selection ) =>
        this.props.updateCanvasDataParams( { [param]: selection.value } );

    render(){
        const { canvasParams, domainGroups, tabIndex } = this.props;

        const tabContent = [
            <CanvasSettingsTabGeneral
                canvasParams={canvasParams}
                domainGroups={domainGroups}
                handleOptionChange={this.handleOptionChange}
            />,
        ];

        return tabContent[tabIndex];
    }
};

CanvasSettingsContentContainer.propTypes = {
    canvasParams: PropTypes.object.isRequired,
    domainGroups: PropTypes.array,
    tabIndex: PropTypes.number.isRequired,
    updateCanvasDataParams: PropTypes.func.isRequired,
};

CanvasSettingsContentContainer.defaultProps = {
    domainGroups: [],
};

/* istanbul ignore next */
const mapStateToProps = ( state ) => {
    return {
        canvasParams: canvasFormStateSelector( state ),
        domainGroups: domainGroupsSelector( state ),
    };
};

export default connect( mapStateToProps, { updateCanvasDataParams } )( CanvasSettingsContentContainer ) ;
